import { useQuery } from '@apollo/client'
import { forwardRef, useImperativeHandle } from 'react'
import { useNavigate } from 'react-router-dom'

import { BankTransferZum } from '../../funds'
import { Link, NotificationDialog, Stack, Text } from '../../../components'
import { mutations, queries } from '../../../graphql'
import { calculateGiftAmount } from '../gift-details-math'

export const PaymentUI = forwardRef(({ setIsPaymentUILoading, fundId }, ref) => {
  const { refetch: refetchLinkedZumRailsBanks } = useQuery(queries.paymentMethods.linkedZumRailsBanks, {
    variables: { fundId },
    fetchPolicy: 'network-only',
  })

  useImperativeHandle(ref, () => ({
    getPaymentMethodId: async () => {
      const { data } = await refetchLinkedZumRailsBanks()
      return Number(data?.linkedZumRailsBanks?.[0]?.PaymentMethodId)
    },
  }))

  return (
    <Stack spacing={2}>
      <Text.Body>
        To complete your donation, securely connect your bank account. This allows for a fast, direct transfer from your
        account to your Giving Wallet.
      </Text.Body>
      <BankTransferZum isStepper setIsPaymentUILoading={setIsPaymentUILoading} activeFundId={fundId} />
    </Stack>
  )
})

export async function getPaymentValues({ paymentMethodApi, values }) {
  const paymentMethodId = await paymentMethodApi.current.getPaymentMethodId()
  return {
    ...values,
    paymentMethodId,
  }
}

export function SuccessUI({ grantAmount, donationTargetName, fundId, donationTargetId }) {
  const navigate = useNavigate()

  const handleOnClick = () => {
    navigate(`/funds/${fundId}/activity`)
  }

  return (
    <NotificationDialog
      open
      onClose={handleOnClick}
      type="success"
      title="Thank You for Your Generosity!"
      message={
        <>
          <Text.Body sx={{ mb: 2 }}>
            Your donation of <strong>${Number(grantAmount).toFixed(2)}</strong> to <strong>{donationTargetName}</strong>{' '}
            (<strong>{donationTargetId}</strong>) has been successfully processed.
          </Text.Body>
          <Text.Body>
            Together, we&apos;re making an impact, and we&apos;re so grateful for your support! You can check on the
            status of your gift at anytime from the <Link to={`/funds/${fundId}/activity`}>Activity</Link> page.
          </Text.Body>
        </>
      }
      actions={[{ label: 'Done', onClick: handleOnClick }]}
    />
  )
}
